<template>
    <div>
        <div v-for="month in collection" :class="{ 'col-sm-12 col-md-6 col-lg-6 col-xl-6': (toSwap != null || $parent.isQuickAdd) && collection[1].length, 'col-sm-12 col-md-12 col-lg-12 col-xl-12': (toSwap == null && !$parent.isQuickAdd) || !collection[1].length }" v-if="month.length > 0">
            <transition-group name="list">
                <div class="box-layout-inner" v-for="(item, key) in month" v-bind:key="key" :class="{ 'quick-form': toSwap != null || $parent.isQuickAdd}">
                    <div class="title-block" >
                        {{ item.month + ' ' + item.year }}
                    </div>

                    <div class="date-selection-blocks" v-for="(dates, week_id) in item.weeks" v-if="dates.state_id == 2 || dates.state_id == 3"><!-- AVAILABLE OR CALL TO BOOK -->
                        <div class="date-inner" v-for="(day, key) in days"><!-- ON SALE -->
                            <div class="title-block" v-show="dates.show_date">
                                {{ day }}
                            </div>

                            <div class="date-block">
                                <div class="fields selection" :class="{ 'checked': selected.indexOf(dates[key].package_id+'|'+dates[key].date.toShortDateString(true)) > -1}" v-if="dates[key] != undefined">
                                    <input type="checkbox" :name="item.month+'-'+dates[key].date.getDate()" :id="item.month+'-'+dates[key].date.getDate()" :value="dates[key].package_id+'|'+dates[key].date.toShortDateString(true)" :disabled="dates[key].availability <= 0" v-model="selected"/>
                                    <label :for="item.month+'-'+dates[key].date.getDate()">
                                        <div class="title" v-html="dates[key].date.getDate()"></div>

                                        <div class="checkbox horizontal" v-if="dates[key].state_id == 2"></div>

                                        <span class="info-tab horizontal" :data-tooltipOver="item.month+'-'+dates[key].date.getDate()" v-else><i class="fa fa-phone"></i></span>
                                    </label>
                                    <div class="tooltipShow" :id="'tooltipShow-'+item.month+'-'+dates[key].date.getDate()" v-if="dates[key].state_id == 3">
                                        {{ $parent.locale.text_ctb_tooltip }}
                                    </div>
                                </div>
                                <div class="fields selection" v-else>

                                </div>
                            </div>
                            <div v-if="dates[key] != undefined && dates[key].state_id == 2 && dates[key].availability > 0 && dates[key].availability < 10" class="availability-block limited-spaces">
                                Spaces Left: {{ dates[key].availability }}
                            </div>
                            <div v-else-if="dates[key] != undefined && dates[key].availability <= 0" class="availability-block fully-booked">
                                Sold Out
                            </div>
                            <div v-else-if="dates[key] != undefined && dates[key].state_id == 3" class="availability-block call-to-book">
                                <a style="color: white;" href="tel:0114 263 2160">Call to Book</a>
                            </div>
                            <div v-else-if="dates[key] != undefined && dates[key].availability >= 10" class="availability-block spaces-available">
                                Available
                            </div>
                        </div>
                    </div>
                    
                    <!-- <div class="date-selection-blocks" v-else-if="dates.state_id == 3 || (dates.state_id == 2 && dates.current_week === true)"> */ -->
                    
                    <div class="date-selection-blocks" v-else-if="dates.state_id == 3">
                        <a class="date-inner full-width call-to-book" href="tel:0114 263 2160"><!-- CALL TO BOOK -->
                            <span><i class="fa fa-phone"></i> {{ $parent.locale.text_individual_days_call_to_book }} <span v-html="Object.keys(dates).map(key => { return dates[key]; })[0].date.formatRange(dates.map(function(a) {return a.date;}), false)"></span></span>
                        </a>
                    </div>
                    <div class="date-selection-blocks" v-else-if="dates.state_id == 4">
                        <div class="date-inner full-width sold-out"><!-- SOLD OUT -->
                            <span><i class="fa fa-times"></i>The <span v-html="Object.keys(dates).map(key => { return dates[key]; })[0].date.formatRange(dates.map(function(a) {return a.date;}), false)"></span> {{ $parent.locale.text_individual_days_sold_out }}</span>
                        </div>
                    </div>
                    <div class="date-selection-blocks" v-else-if="dates.state_id == 5">
                        <div class="date-inner full-width cancelled"><!-- CANCELLED -->
                            <span><i class="fa fa-times"></i>The <span v-html="Object.keys(dates).map(key => { return dates[key]; })[0].date.formatRange(dates.map(function(a) {return a.date;}), false)"></span> {{ $parent.locale.text_individual_days_cancelled }}</span>
                        </div>
                    </div>
                </div>
            </transition-group>
        </div>
    </div>
</template>

<script>

    export default {
        props: ['packages', 'selection', 'toSwap', 'current'],
        data () {
            return {
                months: [],
                collection: [],
                selected: [],
                days: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'],
            }
        },
        watch: {
            "selected": function () {
                this.selection.days_running = [];
                this.selection.packages = [];

                this.selected.forEach(day_package => {
                    var package_id = day_package.split('|')[0];
					//Checking whether the date selected is the most recent date, if so set the current package to this date
					if(day_package.split('|')[1] < this.current.start_date) {
						//Searching through the available packages to match the selected date and getting the first occurance
						var found_package = $.grep(this.packages, function(e){ return e.id == package_id; })[0];
						if(found_package)
							this.$parent.current = found_package;
					}
                    this.selection.packages[package_id] = package_id;
                    if((new Date(day_package.split('|')[1])).toShortDateString(true) >= (new Date()).toShortDateString(true)) {
                        this.selection.days_running[package_id] = this.selection.days_running[package_id] || [];
                        this.selection.days_running[package_id].push(day_package.split('|')[1]);
                    }
                })
                // Persist selections to localStorage
                localStorage.setItem('individualDaysSelected', JSON.stringify(this.selected));
            },
            'months': function () {
                var temp = [[], []];
                this.months.forEach((month, key) => {
                    var length = this.months.length;
                    if((length % 2 && key <= length/2) || (!(length % 2) && key < length/2))
                        temp[0].push(month);
                    else
                        temp[1].push(month);
                })
                this.collection = temp;
            }
        },
        computed: {
            available_dates: function () {
                var result = [];
                this.packages.forEach(packageObject => {
                    if(packageObject.package_state_id == 1)
                        return false; //Not listed

                    let dateNow = new Date();
                    let slotsAvailablePerDay = packageObject.availability;

                    packageObject.days_running.forEach(dateString => {
                        var dateArray = dateString.split("-");
                        var date = new Date(dateArray[0], dateArray[1]-1, dateArray[2]);

                        //Checking whether the date is a previous date, if is do nothing here
                        if(date.toShortDateString(true) >= (new Date()).toShortDateString(true)) {
                            result[date.getMonth()] = result[date.getMonth()] || {year: date.getFullYear(), month: date.getStrMonth(), month_short: date.getStrMonth('short'), weeks: []};
                            result[date.getMonth()].weeks[date.getWeek()] = result[date.getMonth()].weeks[date.getWeek()] || [];
                            result[date.getMonth()].weeks[date.getWeek()][date.getDay()-1] = {
                                date,
                                package_id: packageObject.id,
                                state_id: packageObject.package_state_id,
                                availability: slotsAvailablePerDay[dateString]
                            }
                        }
                    })
                })
                this.months = result.filter(function (item) {
                    return item.weeks.length > 0;
                });
                var dates_shown = false,
                    nowDate = new Date();
                this.months.forEach((item, key) => {
                    this.months[key].weeks = this.months[key].weeks.filter((item, dateKey) => {
                        var state_id = 2,
                            current_week = false,
                                slotsAvailable = 0;
                        item.forEach(function (date) {
                            state_id = date.state_id;
                            slotsAvailable = date.availability;
                            if(date.date.getWeek() === nowDate.getWeek() && date.date.getMonth() === nowDate.getMonth())
                                current_week = true;
                        })

                        if((state_id == 2 || state_id == 3) && dates_shown == false) {
                            this.months[key].weeks[dateKey].show_date = true;

                            dates_shown = true;
                        }

                        this.months[key].weeks[dateKey].state_id = state_id;
                        this.months[key].weeks[dateKey].current_week = current_week;

                        this.months[key].weeks[dateKey] = this.months[key].weeks[dateKey].filter(dateObject => {
                            return dateObject != undefined;
                        })

                        return item != undefined;
                    })
                    dates_shown = false;
                })
                this.months.forEach(month => {
                    month.weeks.filter(week => {
                        return week != undefined;
                    })
                })

                this.months.sort((a, b) => {
                    if(a.year == b.year) {
                        return a.month_shortNum - b.month_shortNum;
                    }
                    return a.year - b.year;
                });
            }
        },
        created () {
            this.available_dates;
            
            // Restore from localStorage first (survives page navigation)
            const storedSelections = localStorage.getItem('individualDaysSelected');
            if (storedSelections) {
                try {
                    this.selected = JSON.parse(storedSelections);
                } catch (e) {
                    console.error('Failed to parse stored selections:', e);
                }
            }
            
            // Also try to restore from selection.days_running as fallback
            if (this.selected.length === 0 && this.selection.days_running) {
                Object.keys(this.selection.days_running).forEach(packageId => {
                    this.selection.days_running[packageId].forEach(date => {
                        const value = packageId + '|' + date;
                        if (this.selected.indexOf(value) === -1) {
                            this.selected.push(value);
                        }
                    });
                });
            }

            if(this.toSwap) {
                axios.get('/camp-booking/bookings/'+this.$root.getCookie('kingscamps_booking_id')+'/items/' + this.toSwap.id + '/similar')
                    .then(response => {
                        var packages = response.data.data;
                        packages.forEach(pack => {
                            //Only want to continue if the item is not cancelled
                            if(pack.booking_item_state_id != 4) {
                                pack.days_attending.forEach(day => {
                                    this.selected.push(pack.package_id + '|' + day);
                                })
                                this.selection.days_running[pack.package_id] = pack.days_attending.filter($date => {
                                    return (new Date($date)).toShortDateString(true) >= (new Date()).toShortDateString(true);
                                });
                                }
                        });
                    })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// IndividualDays.vue?7d9ff040